<template>
  <div id="app">
    <router-view></router-view>
	
    <!-- 底部导航栏 -->
    <van-tabbar v-model="activeTab" route>
      <van-tabbar-item replace to="/" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item replace to="/category" icon="apps-o">分类</van-tabbar-item>
      <van-tabbar-item replace to="/cart" icon="shopping-cart-o">购物车</van-tabbar-item>
      <van-tabbar-item replace to="/profile" icon="user-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      activeTab: 0
    }
  },
  watch: {
    $route(to) {
      // 根据路由路径设置激活的标签
      switch (to.path) {
        case '/':
          this.activeTab = 0
          break
        case '/category':
          this.activeTab = 1
          break
        case '/cart':
          this.activeTab = 2
          break
        case '/profile':
          this.activeTab = 3
          break
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
  padding-bottom: 50px;
}
</style>
